export default __webpack_public_path__ + "static/media/mint_btn.1a12aa3e.png";